import axios from 'axios'
import { ElMessage } from 'element-plus'
import 'element-plus/dist/index.css'

// 开发环境使用代理，生产环境直接访问接口
const isDev = import.meta.env.DEV

// 创建 axios 实例
const service = axios.create({
  baseURL: isDev ? '/api' : 'https://www-api.930pm.cn/',
  timeout: 150000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  }
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  error => {
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// // 响应拦截器
// service.interceptors.response.use(
//   response => {
//     const res = response.data
//     if (res.code !== 200) {
//       ElMessage.error(res.message || '请求失败')  // 修改这里
//       return Promise.reject(res)
//     }
//     return res.data
//   },
//   error => {
//     console.error('响应错误:', error)
//     ElMessage.error(error.message || '系统错误')  // 修改这里
//     return Promise.reject(error)
//   }
// )
service.interceptors.response.use(
    response => {
      const res = response.data
      // 根据实际接口返回格式调整
      return res
    },
    error => {
      console.error('响应错误:', error)
      ElMessage.error(error.message || '网络错误')
      return Promise.reject(error)
    }
  )

export function get(url, params) {
  return service({
    url,
    method: 'get',
    params
  })
}

export function post(url, data) {
  return service({
    url,
    method: 'post',
    data
  })
}

export function put(url, data) {
  return service({
    url,
    method: 'put',
    data
  })
}

export function del(url, params) {
  return service({
    url,
    method: 'delete',
    params
  })
}

export default service